import { css } from "@octopus-energy/coral-design/css"

const solarPanelsWithWindmillsClass = css({
    "& g.rotate-center": {
        animationName: "OEFRRotate",
        animationDuration: "2s",
        animationIterationCount: "infinite",
        animationTimingFunction: "linear",
        transformBox: "fill-box",
        transformOrigin: "28px 26px",
    },
})

export const SolarPanelsWithWindmills = () => {
    return (
        <svg
            width={180}
            height={113}
            viewBox="0 0 180 113"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={solarPanelsWithWindmillsClass}
        >
            <path
                d="M112.792 113H111.209C111.045 112.992 110.883 112.94 110.734 112.845C110.584 112.75 110.449 112.615 110.337 112.448C110.225 112.28 110.137 112.084 110.08 111.869C110.022 111.654 109.995 111.426 110.001 111.196L110.834 29.7454C110.822 29.5219 110.844 29.2975 110.898 29.0862C110.951 28.8749 111.035 28.6813 111.145 28.5175C111.254 28.3537 111.387 28.2232 111.534 28.1341C111.681 28.0451 111.84 27.9994 112 28C112.163 27.9999 112.323 28.0454 112.472 28.1338C112.622 28.2222 112.757 28.3517 112.87 28.5146C112.982 28.6774 113.07 28.8704 113.129 29.0818C113.187 29.2933 113.214 29.519 113.208 29.7454L114 111.196C113.991 111.651 113.863 112.086 113.641 112.418C113.418 112.751 113.116 112.958 112.792 113Z"
                fill="#0A604A"
                opacity="0.8"
            />
            <path
                d="M139.792 113H138.209C138.045 112.995 137.883 112.958 137.734 112.891C137.584 112.824 137.449 112.729 137.337 112.61C137.225 112.492 137.137 112.353 137.08 112.202C137.022 112.05 136.995 111.889 137.001 111.727L137.834 54.232C137.822 54.0743 137.844 53.9159 137.898 53.7667C137.951 53.6176 138.035 53.4809 138.145 53.3653C138.254 53.2497 138.387 53.1575 138.534 53.0947C138.681 53.0318 138.84 52.9996 139 53C139.163 52.9999 139.323 53.032 139.472 53.0944C139.622 53.1568 139.757 53.2482 139.87 53.3632C139.982 53.4782 140.07 53.6144 140.129 53.7637C140.187 53.9129 140.214 54.0722 140.208 54.232L141 111.727C140.991 112.048 140.863 112.355 140.641 112.589C140.418 112.824 140.116 112.97 139.792 113Z"
                fill="#0A604A"
                opacity="0.8"
            />
            <g
                className="rotate-center"
                opacity="0.8"
            >
                <path
                    d="M108.446 21.6979L111.455 26L122.939 0.972961C123.012 0.812667 123.02 0.63257 122.961 0.466993C122.903 0.301416 122.782 0.161939 122.622 0.0751326C122.461 -0.000824496 122.277 -0.0199453 122.103 0.0212238C121.928 0.0623929 121.775 0.161136 121.672 0.299593L108.446 19.0792C108.156 19.4608 108 19.9188 108 20.3886C108 20.8584 108.156 21.3163 108.446 21.6979Z"
                    fill="#19EEB6"
                />
                <path
                    d="M117.129 26.0083L112 26.4521L128.811 47.7557C128.92 47.8804 129.069 47.9634 129.233 47.9904C129.398 48.0175 129.566 47.9868 129.71 47.9037C129.843 47.8021 129.937 47.6593 129.978 47.4983C130.018 47.3373 130.003 47.1674 129.934 47.016L119.451 27.2658C119.232 26.8541 118.895 26.5152 118.482 26.2916C118.069 26.0679 117.599 25.9694 117.129 26.0083Z"
                    fill="#19EEB6"
                />
                <path
                    d="M109.73 31.6474L112 27L84.6099 30.4106C84.5219 30.4151 84.4357 30.4375 84.3568 30.4763C84.2779 30.5152 84.208 30.5697 84.1512 30.6364C84.0945 30.7032 84.0521 30.7808 84.0269 30.8645C84.0017 30.9481 83.9941 31.036 84.0046 31.1227C84.0043 31.2953 84.0709 31.4614 84.1905 31.5869C84.3101 31.7124 84.4737 31.7877 84.6477 31.7973L107.422 32.9966C107.898 33.0217 108.371 32.9071 108.782 32.6671C109.192 32.4271 109.522 32.0723 109.73 31.6474Z"
                    fill="#19EEB6"
                />
            </g>
            <g
                className="rotate-center"
                opacity="0.8"
            >
                <path
                    d="M135.446 46.6979L138.455 51L149.939 25.973C150.012 25.8127 150.02 25.6326 149.961 25.467C149.903 25.3014 149.782 25.1619 149.622 25.0751C149.461 24.9992 149.277 24.9801 149.103 25.0212C148.928 25.0624 148.775 25.1611 148.672 25.2996L135.446 44.0792C135.156 44.4608 135 44.9188 135 45.3886C135 45.8584 135.156 46.3163 135.446 46.6979Z"
                    fill="#19EEB6"
                />
                <path
                    d="M144.129 51.0083L139 51.4521L155.811 72.7557C155.92 72.8804 156.069 72.9634 156.233 72.9904C156.398 73.0175 156.566 72.9868 156.71 72.9037C156.843 72.8021 156.937 72.6593 156.978 72.4983C157.018 72.3373 157.003 72.1674 156.934 72.016L146.451 52.2658C146.232 51.8541 145.895 51.5152 145.482 51.2916C145.069 51.0679 144.599 50.9694 144.129 51.0083Z"
                    fill="#19EEB6"
                />
                <path
                    d="M136.73 56.6474L139 52L111.61 55.4106C111.522 55.4151 111.436 55.4375 111.357 55.4763C111.278 55.5152 111.208 55.5697 111.151 55.6365C111.094 55.7032 111.052 55.7808 111.027 55.8645C111.002 55.9481 110.994 56.036 111.005 56.1227C111.004 56.2953 111.071 56.4614 111.19 56.5869C111.31 56.7124 111.474 56.7877 111.648 56.7973L134.422 57.9966C134.898 58.0217 135.371 57.9071 135.782 57.6671C136.192 57.4271 136.522 57.0723 136.73 56.6474Z"
                    fill="#19EEB6"
                />
            </g>
            <path
                d="M111.5 29C112.881 29 114 27.8807 114 26.5C114 25.1193 112.881 24 111.5 24C110.119 24 109 25.1193 109 26.5C109 27.8807 110.119 29 111.5 29Z"
                fill="#0A604A"
                opacity="0.8"
            />
            <path
                d="M138.5 54C139.881 54 141 52.8807 141 51.5C141 50.1193 139.881 49 138.5 49C137.119 49 136 50.1193 136 51.5C136 52.8807 137.119 54 138.5 54Z"
                fill="#0A604A"
                opacity="0.8"
            />
            <path
                d="M60.0365 93.4921L57.9058 93.4824L57.8187 112.658L59.9494 112.667L60.0365 93.4921Z"
                fill="#0A604A"
                opacity="0.8"
            />
            <path
                d="M14.0365 93.4921L11.9058 93.4824L11.8187 112.658L13.9494 112.667L14.0365 93.4921Z"
                fill="#0A604A"
                opacity="0.8"
            />
            <path
                d="M56.2535 73H46L50.8604 81.9885H61.0474L56.2535 73Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M57.7183 73L62.5788 81.9885H71.1677L66.3739 73H57.7183Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M66.6402 92.3086L61.7798 83.3201H51.5928L56.4533 92.3086H66.6402Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M83.7516 102.629H92.6735L87.8131 93.6402H78.9577L83.7516 102.629Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M78.2254 92.3086H87.0807L82.2202 83.3201H73.3649L78.2254 92.3086Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M68.105 92.3086H76.694L71.9001 83.3201H63.3111L68.105 92.3086Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M87.5467 112.483L82.9526 103.96H74.3636L78.9578 112.483H87.5467Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M72.8989 103.96H62.7785L67.3726 112.483H77.4264L72.8989 103.96Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M72.6991 81.9885H81.4878L76.6274 73H67.8387L72.6991 81.9885Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M93.4059 103.96H84.484L89.0781 112.483H98L93.4059 103.96Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M77.4264 93.6402H68.8374L73.6978 102.629H82.2868L77.4264 93.6402Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M67.306 93.6402H57.1857L62.0461 102.629H72.1664L67.306 93.6402Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M10.2535 72H0L4.86044 80.9885H15.0474L10.2535 72Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M11.7183 72L16.5787 80.9885H25.1677L20.3739 72H11.7183Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M20.6402 91.3086L15.7798 82.3201H5.59283L10.4533 91.3086H20.6402Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M37.7516 101.629H46.6735L41.8131 92.6402H32.9577L37.7516 101.629Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M32.2254 91.3086H41.0807L36.2202 82.3201H27.3649L32.2254 91.3086Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M22.105 91.3086H30.694L25.9001 82.3201H17.3111L22.105 91.3086Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M41.5467 111.483L36.9526 102.96H28.3636L32.9578 111.483H41.5467Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M26.8989 102.96H16.7785L21.3726 111.483H31.4264L26.8989 102.96Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M26.6991 80.9885H35.4878L30.6274 72H21.8387L26.6991 80.9885Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M47.4059 102.96H38.484L43.0781 111.483H52L47.4059 102.96Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M31.4264 92.6402H22.8374L27.6978 101.629H36.2868L31.4264 92.6402Z"
                fill="#19EEB6"
                opacity="0.8"
            />
            <path
                d="M21.306 92.6402H11.1857L16.0461 101.629H26.1664L21.306 92.6402Z"
                fill="#19EEB6"
                opacity="0.8"
            />
        </svg>
    )
}
